import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, Row } from 'reactstrap';
import '../../assets/css/login.scss';
import ImageHelper from '../../helpers/ImageHelper';
import ViewHelper from '../../helpers/ViewHelper';
import BinDiscountCard from './BinDiscountCard';
import TermsModal from './TermsModal';
class BinDiscountsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      loadingCode: false,
      showTermModal: false,
      error: '',
      bindiscount: '',
      banks: []
    };
  }

  componentDidMount() {
    let banks = ViewHelper.getCustomizedBinDiscounts(this.props.bindiscounts, this.props._location);
    this.setState({ banks: banks });
  }
  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      let banks = ViewHelper.getCustomizedBinDiscounts(this.props.bindiscounts, this.props._location);
      this.setState({ banks: banks });
    }
  }
  async toggleTermModal() {
    this.setState({
      showTermModal: !this.state.showTermModal
    });
  }
  openTerms(bindiscount) {
    this.setState({ bindiscount: bindiscount });
    this.toggleTermModal();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.showTermModal && (
          <TermsModal
            toggleModal={this.toggleTermModal.bind(this)}
            showModal={this.state.showTermModal}
            bindiscount={this.state.bindiscount}
            _location={this.props._location}
          />
        )
        }
        <Modal
          isOpen={this.props.showModal}
          toggle={this.props.toggleModal}
          className="modal sub-modal-bin"
        >
          <div className="modal-header no-border primary-color">
            <h5 className="modal-title fw-bold fs-4 primary-font-color">Discounts on Bank Cards</h5>
            <div
              className={`close-icon`}
              onClick={this.props.toggleModal}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTimes} color='var(--card-subtitle-color)' size={'1x'} />
            </div>
          </div>

          <ModalBody className="primary-color" style={{ overflowX: 'hidden' }}>
            {this.state.banks.length > 0 ?
              this.state.banks && this.state.banks.map((bank) => {
                return (
                  <Row className='p-4'>
                    <div>
                      <img
                        className='mb-4'
                        src={
                          ImageHelper.getImageURL(
                            bank.bank_rect_img,
                            ''
                          )
                        }
                        style={{ width: '150px', height: '80px' }}
                        alt=""
                      />
                      <Row>
                        {bank.bindiscounts && bank.bindiscounts.map((bindiscount) => {
                          return (
                            <BinDiscountCard bindiscount={bindiscount} openTerms={this.openTerms.bind(this)} />
                          )
                        })}
                      </Row>
                    </div>
                  </Row>
                );
              })
              :
              <h4>No Bin Discount Available.</h4>
            }
          </ModalBody>
          <ModalFooter className="no-border primary-color d-flex justify-content-center">

          </ModalFooter>

        </Modal>
      </React.Fragment>
    );
  }
}

export default BinDiscountsModal;
